/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: BCC Pubs
  Author: SweetAs
  Author URL: http://sweetas.xyz
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [

    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          redirect: '/login'
        },             
        {
          path: '/pubs/:ipid',
          name: 'pubs-view',
          component: () => import('@/views/apps/pubs/ThumbView.vue'),
          meta: {
            breadcrumb: [{ title: 'Publications', active: true }],
            pageTitle: 'Publications',
            rule: 'admin'
          }
        },        
        {
          path: '/cart',
          name: 'pubs-cart',
          component: () => import('./views/apps/pubs/Cart.vue'),
          meta: {
            breadcrumb: [
              { title: 'Publications'},
              { title: 'Cart', active: true }
            ],
            pageTitle: 'Cart',
            rule: 'admin'
          }
        },
        {
          path: '/payment',
          name: 'pubs-payment',
          component: () => import('./views/pages/Payment.vue'),
          meta: {
            breadcrumb: [
              { title: 'Publications'},
              { title: 'Payment', active: true }
            ],
            pageTitle: 'Payment',
            rule: 'admin'
          }
        },
        {
          path: '/admin',
          name: 'page-admin',
          component: () => import('@/views/pages/Admin.vue'),
          meta: {
            rule: 'admin'
          }
        },
        {
          path: '/admin/:id',
          name: 'page-admin-edit',
          component: () => import('@/views/pages/AdminEdit.vue'),
          meta: {
            rule: 'admin'
          }
        },
        {
          path: '/search',
          name: 'page-search',
          component: () => import('@/views/pages/Search.vue'),
          meta: {
            rule: 'admin'
          }
        },
      ]
    },

    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // ============================================================================= 
        // {
        //   path: '/search',
        //   name: 'page-search',
        //   component: () => import('@/views/pages/Search.vue'),
        //   meta: {
        //     rule: 'admin'
        //   }
        // },
        {
          path: '/login',
          name: 'page-login',
          component: () => import('@/views/pages/login/Login.vue'),
          meta: {
            rule: 'editor'
          }
        },
        // {
        //   path: '/admin',
        //   name: 'page-admin',
        //   component: () => import('@/views/pages/Admin.vue'),
        //   meta: {
        //     rule: 'admin'
        //   }
        // },
        // {
        //   path: '/admin/:id',
        //   name: 'page-admin-edit',
        //   component: () => import('@/views/pages/AdminEdit.vue'),
        //   meta: {
        //     rule: 'admin'
        //   }
        // },
        {
          path: '/error-404',
          redirect: '/'          
        },
        {
          path: '/error-500',
          name: 'page-error-500',
          component: () => import('@/views/pages/Error500.vue'),
          meta: {
            rule: 'editor'
          }
        },        
        {
          path: '/maintenance',
          name: 'page-maintenance',
          component: () => import('@/views/pages/Maintenance.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/reset/:id',
          name: 'page-reset',
          component: () => import('@/views/pages/PasswordReset.vue'),  
          meta: {
            rule: 'editor'
          }        
        }, 
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
    
  let initialRole = 'editor'
  const userInfo = JSON.parse(localStorage.getItem('userInfo'))
  if (userInfo && userInfo.userRole) initialRole = userInfo.userRole

  // If auth required, check login. If login fails redirect to login page
  if (initialRole !== 'admin' && initialRole !== to.meta.rule) {    
    router.push({ path: '/login', query: { to: to.path } })
  }
  return next()
  // Specify the current path as the customState parameter, meaning it
  // will be returned to the application after auth
  // auth.login({ target: to.path });
})

export default router
